/**
 * Converts kilograms to pounds.
 *
 * @param {number} kgs The number to convert.
 */
const kgsToLbs = ( kgs: number ) => kgs * 2.2046

export default kgsToLbs
